import React from 'react';
import {styled} from 'styled-components';
import {StyledProps, typographyBodyStyles} from '../../modules/common/styles';

export interface PromoDetail {
    title: string;
    value: string[];
}

interface Props extends StyledProps {
    promoDetail: PromoDetail;
}

const unstyledPromoDetailLine = (props: Props): JSX.Element => {
    const {className, promoDetail} = props;
    const {title, value} = promoDetail;

    const titleContent =
        title == '' ? null : (
            <p>
                <strong>{title}</strong>
            </p>
        );

    if (!value.length) {
        throw new Error('value can not be empty');
    }
    if (value.length === 1) {
        return (
            <div className={className}>
                {titleContent}
                <p>{value}</p>
            </div>
        );
    } else {
        return (
            <div className={className}>
                {titleContent}
                <ul>
                    {value.map((obj, i) => (
                        <li key={i}>{obj}</li>
                    ))}
                </ul>
            </div>
        );
    }
};

/**
 * Renders a PromoDetail object
 */
export const PromoDetailLine = styled(unstyledPromoDetailLine)`
    p {
        margin: 0;
        ${typographyBodyStyles}
    }
    ul {
        margin: 0;
        padding-left: 32px;
    }
`;
